import { atomWithStorage } from 'jotai/utils';

import { storage } from '@service-initiation/shared-utils-jotai';

import { type BillingDetails, type BillingDetailsAddress } from '../types';

const DefaultBillingDetails: BillingDetails = {
  billingAddress: {
    city: '',
    line1: '',
    line2: '',
    postalCode: '',
    state: '',
  },
  billingIsSame: true,
  firstName: '',
  lastName: '',
  payment_intent_id: '',
  stripeContext: {
    stripe: null,
    stripeElements: null,
  },
};

export type BillingDetailsAtom = Partial<
  Omit<BillingDetails, 'billingAddress'> & {
    billingAddress: Partial<BillingDetailsAddress>;
  }
>;
export const billingDetailsAtom = atomWithStorage<
  BillingDetailsAtom | undefined
>(
  'si-tec-car-billing-details',
  DefaultBillingDetails,
  storage<BillingDetailsAtom | undefined>(),
  {
    getOnInit: true,
  }
);
